module.exports = __webpack_public_path__ + "img/car.1359c8db.png";